module.exports = __webpack_public_path__ + "static/media/dispatch_systemmoduleA-img.5ae0c8af.png";